export default "__VITE_ASSET__Ba4gf7ag__"